import { Input, Checkbox } from "../../../../../common/Input";

export function LegendDetailsTab({
  form,
  errorState,
  handleInputChange
}) {
  return (
    <div className="rounded-lg border border-gray-300 bg-white px-4 shadow-sm">
      <div className="border-b border-gray-300 py-1">
        <h3 className="font-medium text-gray-700">KPI Legend Information</h3>
      </div>
      <div className="grid grid-cols-1 gap-4 pb-3 pt-3">
        <Input
          type="textarea"
          label="Description:"
          value={form.description}
          onChange={(e) => handleInputChange('description', e.target.value)}
          placeholder="Enter description for this code"
          isRequired={true}
          rows={2}
          error={errorState.description && !form.description}
          errorMessage={errorState.description}
        />

        <Checkbox
          label={"Is Active?"}
          checked={form.isActive !== undefined ? form.isActive : false}
          onChange={(e) => handleInputChange('isActive', e.target.checked)}
          tooltip="Active | Inactive"
        />
      </div>
    </div>
  );
}